import { render, staticRenderFns } from "./AddEditProductModal.vue?vue&type=template&id=6c41d21a&scoped=true&"
import script from "./AddEditProductModal.vue?vue&type=script&lang=js&"
export * from "./AddEditProductModal.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProductModal.vue?vue&type=style&index=0&id=6c41d21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c41d21a",
  null
  
)

export default component.exports